import CreateInventoryItem from 'components/CreateInventoryItem';
import React from 'react';

const CreateInventoryItemPage = (props) => {
  return (
    <CreateInventoryItem {...props} />
  );
};

export { CreateInventoryItemPage };